function dropdown() {
    const mediaQuery = window.matchMedia('(max-width: 767px)');
    const head = document.querySelector('.gh-navigation');
    const menu = head?.querySelector('.gh-navigation-menu');
    const nav = menu?.querySelector('.nav');
    if (!nav || !head) return;

    const logo = document.querySelector('.gh-navigation-logo');
    const navHTML = nav.innerHTML;
    const TOGGLE_RESERVE = 64;
    let clickBound = false;
    let resizeTimer;

    function whenLogoReady(callback) {
        if (!logo) {
            callback();
            return;
        }

        const img = logo.querySelector('img');
        if (!img) {
            callback();
            return;
        }

        if (img.complete) {
            callback();
            return;
        }

        img.addEventListener('load', callback, { once: true });
        img.addEventListener('error', callback, { once: true });
    }

    function scheduleDropdown() {
        const run = function () {
            requestAnimationFrame(makeDropdown);
        };

        if ('requestIdleCallback' in window) {
            requestIdleCallback(run, { timeout: 2000 });
        } else {
            run();
        }
    }

    function bindDropdownClick() {
        if (clickBound) return;
        clickBound = true;

        window.addEventListener('click', function (e) {
            const toggle = nav.querySelector('.gh-more-toggle');
            if (!toggle) return;

            if (head.classList.contains('is-dropdown-open')) {
                head.classList.remove('is-dropdown-open');
            } else if (toggle.contains(e.target)) {
                head.classList.add('is-dropdown-open');
            }
        });
    }

    function makeDropdown() {
        if (mediaQuery.matches) return;

        nav.innerHTML = navHTML;
        head.classList.remove('is-dropdown-loaded', 'is-dropdown-open', 'is-dropdown-mega');

        const menuWidth = menu.offsetWidth;
        const items = Array.from(nav.querySelectorAll(':scope > li'));

        if (!items.length) {
            head.classList.add('is-dropdown-loaded');
            bindDropdownClick();
            return;
        }

        /* Single read pass — avoids forced reflow in a measure/write loop */
        const widths = items.map(function (li) {
            return li.offsetWidth;
        });
        let total = widths.reduce(function (sum, width) {
            return sum + width;
        }, 0);

        let overflow = 0;
        while (items.length - overflow > 0 && total + TOGGLE_RESERVE > menuWidth) {
            overflow++;
            total -= widths[widths.length - overflow];
        }

        if (!overflow) {
            head.classList.add('is-dropdown-loaded');
            bindDropdownClick();
            return;
        }

        const submenuItems = items.slice(items.length - overflow);
        submenuItems.forEach(function (li) {
            li.remove();
        });

        const toggle = document.createElement('button');
        toggle.setAttribute('class', 'gh-more-toggle gh-icon-button');
        toggle.setAttribute('aria-label', 'More');
        toggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor"><path d="M21.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM13.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM5.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0z"></path></svg>';

        const wrapper = document.createElement('div');
        wrapper.setAttribute('class', 'gh-dropdown');

        if (submenuItems.length >= 10) {
            head.classList.add('is-dropdown-mega');
            wrapper.style.gridTemplateRows = 'repeat(' + Math.ceil(submenuItems.length / 2) + ', 1fr)';
        }

        submenuItems.forEach(function (child) {
            wrapper.appendChild(child);
        });

        toggle.appendChild(wrapper);
        nav.appendChild(toggle);

        const toggleRect = toggle.getBoundingClientRect();
        if (toggleRect.left < window.innerWidth / 2) {
            wrapper.classList.add('is-left');
        }

        head.classList.add('is-dropdown-loaded');
        bindDropdownClick();
    }

    if (mediaQuery.matches) {
        const items = nav.querySelectorAll('li');
        items.forEach(function (item, index) {
            item.style.transitionDelay = (0.03 * (index + 1)) + 's';
        });
    }

    whenLogoReady(scheduleDropdown);

    window.addEventListener('load', function () {
        if (!logo) {
            scheduleDropdown();
        }
    });

    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(scheduleDropdown, 150);
    });
}
